import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["formFields", "boothTypeField"]

  connect() {
    console.log("BoothOptionsController connected")
    // console.log(this.formFieldsTarget)
    // console.log(this.boothTypeFieldTarget.value)
    this.#toggleFormFields(this.boothTypeFieldTarget.value)
  }

  handleBoothChange(event) {
    console.log("Booth changed")
    console.log(event.target.value)
    this.#toggleFormFields(event.target.value)
  }

  #toggleFormFields(value) {
    if (value === "0") {
      this.formFieldsTarget.classList.add("hidden")
      window.location.href = "/crush/booths/new"
    } else if (!value) {
      this.formFieldsTarget.classList.add("hidden")
    } else {
      this.formFieldsTarget.classList.remove("hidden")
    }
  }
}
